export { default as CallType } from './CallType'; // ajax 请求类型枚举
export { default as Superagent } from './Superagent'; // ajax 请求对象


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/ajax/index.ts